(function($) {

    // Toggle collapse on submenu
    $('#navbarToggle').on('click', function() {
        var primaryNavigation = $('#primaryNavigation');
        var siteHeader = $('#siteHeader');

        $(this).toggleClass('collapsed');

        // Dropdown toggle setup
        if(primaryNavigation.hasClass('is-active')) {
            primaryNavigation.removeClass('is-active');
            $('body').removeClass('no-scroll');
            siteHeader.removeClass('nav-open');

        } else {
            primaryNavigation.addClass('is-active');
            $('body').addClass('no-scroll');
            siteHeader.addClass('nav-open');
        }
    });

    $('.js-nav-close').on('click', function() {
        var primaryNavigation = $('#primaryNavigation');
        var siteHeader = $('#siteHeader');

        primaryNavigation.removeClass('is-active');
        $('body').removeClass('no-scroll');
        siteHeader.removeClass('nav-open');
    });

    $('.nav-item.dropdown').on('click', function() {
        // var itemHeight = $(this).outerHeight(),
        //     headerHeight = $('#siteHeader .header-container').outerHeight(),
        //     bottomAdjust = (headerHeight*.5);

        // $(this).find('.dropdown-menu').css('top', bottomAdjust);
    });

}(jQuery));
